import axios from 'axios'
//import router from '../router'
import store from '@/store'
import axiosRetry from 'axios-retry';
import Toast from '@/packages/toast/index.js';
// create an axios instance
const service = axios.create({
    timeout: 50000 // request timeout
})
axiosRetry(service, {
    retries: 100,
    shouldResetTimeout: true,
    retryDelay: () => {
        return 5000;
    }
});
// request interceptor
service.interceptors.request.use(
        config => {
            // console.log(config.url);
            if (store.state.app.domain) {
                config.baseURL = 'https://' + store.state.app.domain.replace('gw.', 'task.');
            }
            // Do something before request is sent
            return config
        },
        error => {
            // Do something with request error
            // console.log(error) // for debug
            Promise.reject(error)
        }
    )
    // respone interceptor
service.interceptors.response.use(
    response => {
        const params = response.config.params;

        if (response.data.code != 0) {
            if (params && (params.action == 'login' || params.action == 'set_app_password')) {
                //手势登录或者设置密码的错误处理在调用处处理
            } else {
                Toast.service(response.data.msg);
            }
        }

        return response;
    },
    error => {
        //Toast.service(error)
        return Promise.reject(error)
    }
)

export default service